<template>
  <div class="container">

    <h1 class="title is-2">Contact</h1>

    <div class="columns">

      <div class="column is-6">

        <p>Leave me your details and I'll get back to you as soon as I can.</p>
        <br/>

        <div class="control" v-if="!successfullySubmitted && !failedToSubmit">

          <div class="field">
            <label for="name" class="label">Name</label>
            <input v-model="name"  id="name" type="text" class="input" placeholder="Your name"
                    v-bind:class="{'is-danger': triedSubmit && !$v.name.required}">
          </div>

          <div class="field">
            <label for="email" class="label">Email</label>
            <input v-model="email" id="email" type="text" class="input" placeholder="Your email address"
                  v-bind:class="{'is-danger': triedSubmit && !($v.email.required && $v.email.email)}" >
          </div>

          <div class="field">
            <label for="phone" class="label">Phone</label>
            <input v-model="phone" id="email" type="text" class="input" placeholder="Your phone number">
          </div>

          <div class="field">
            <label for="behalf" class="label">Contacting on behalf of</label>
            <div class="select">
              <select v-model="behalf" id="behalf">
                <option>Myself</option>
                <option>My child</option>
                <option>A school</option>
                <option>Other</option>
              </select>
            </div>
          </div>

          <div v-if="onChildsBehalf()" class="field">
            <label for="child" class="label">Child's name</label>
            <input v-model="child" id="child" type="text" class="input" placeholder="Your child's name">
          </div>
          <div v-if="onSchoolsBehalf()" class="field">
            <label for="school" class="label">School name</label>
            <input v-model="school" id="school" type="text" class="input" placeholder="Name of the school">
          </div>
          <div class="field">
            <label for="message" class="label">Message</label>
            <textarea v-model="message" id="message" type="textarea" rows="4" class="textarea" placeholder="How can I help?"
                  v-bind:class="{'is-danger': triedSubmit && !$v.message.required}" />
          </div>
          <br/>
          <button class="button is-primary" v-on:click="submit">Submit</button>
        </div>

        <div class="success-msg" v-if="successfullySubmitted">
          <p>Thanks for your message! I'll get back to you as soon as possible.</p>
        </div>
        <div class="failure-msg" v-if="failedToSubmit">
          <p class="failure-msg-heading">Sorry! Something went wrong and we were unable to submit your message.</p>
          <br/>
          <p>Please see alternative contact options below:</p>
          <ul>
            <li> - You can email me: contact at {{domain}} dot com</li>
            <li> - Or you can send me a message on twitter: <a href="https://twitter.com/ChessCoaches">@ChessCoaches</a></li>
          </ul>
          <br/>
          <p>Note: we have seen intermittent issues with this form in the past, please do let me know if you have seen this message to help us investigate further.</p>
        </div>
      </div>

      <div class="column is-6">  
        <figure class="image">
          <img src="../assets/Phil5.jpg" alt="Phil Makepeace British Universities' Chess Championship." />
        </figure>
      </div>

    </div>
  </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'

export default {
  data () {
    return {
      // data model
      behalf: 'Myself',
      child: '',
      email: '',
      message: '',
      name: '',
      phone: '',
      school: '',
      triedSubmit: false,
      successfullySubmitted: false,
      failedToSubmit: false,
      domain: 'makepeacewithchess',

      onChildsBehalf () {
        return this.behalf === 'My child'
      },
      onSchoolsBehalf () {
        return this.behalf === 'A school'
      }
    }
  },
  head: {
    title: function () {
      return {
        inner: 'Contact',
        separator: '-'
      }
    },
    meta: [
      { name: 'description', content: 'Contact me to schedule some one-on-one chess coaching or for more information about our chess clubs in schools.' }
    ]
  },
  methods: {
    submit: function (event) {
      this.triedSubmit = true
      if (this.validates()) {
        this.$http.post('https://formspree.io/xoqkdrgb', {
          'name': this.name,
          'email': this.email,
          'behalf': this.behalf,
          'message': this.message,
          'phone': this.phone,
          'school': this.school,
          'child': this.child
        }).then(response => {
          this.successfullySubmitted = true
        }, errResponse => {
          this.failedToSubmit = true
          console.log('Failed to submit form. ' + errResponse)
        })
      } else {
        console.log('Invalid form entry, please try again.')
      }
    },
    validates: function () {
      return this.$v.name.required && this.$v.email.required && this.$v.email.email && this.$v.message.required
    }
  },
  validations: {
    name: {
      required
    },
    email: {
      required,
      email
    },
    message: {
      required
    }
  }
}
</script>

<style lang="sass">
.success-msg
  font-weight: bold

.failure-msg-heading
  font-weight: bold

</style>



// WEBPACK FOOTER //
// Contact.vue?1fbb7e59